<template>
  <div class="scenes-bg">
    <!--group-->
    <group-list :curr-group-id="currentGroupIdx" :group-list="sceneGroups" @titleClick="titleClick" @editGroup="editGroup"
      :is-dragging="false" @dragEnd="groupDragEnd"></group-list>
    <!--scenes-->
    <scene-list :curr-scene="selectScene" :scenes-list="sceneGroups[currentGroupIdx].scenes" :all-scenes="vrbase.scenes"
      @addScene="onClickAddScene" @loadScene="loadScene" :is-dragging="false" :currGroupId="currentGroupIdx"
      @dragEnd="sceneDragEnd"></scene-list>
    <!-- 編輯場景options組件 -->
    <edit-options :options="sceneOptions" @onclick="sceneOption" :is-fixed="false"></edit-options>


    <!-- 編輯組options組件 -->
    <BottomTip :visible="editGroupVisible" @close="editGroupVisible = false" :item="groupOptions"
      @itemClick="groupOption"></BottomTip>

    <!-- 新增場景組件 -->
    <BottomTip :visible="addScenesGroupVisible" @close="addScenesGroupVisible = false" :item="addSceneOptions"
      @itemClick="addSceneOption"></BottomTip>

    <!--重命名-->
    <a-modal v-model="renameVisible" :title="$t('actionTitles.rename')" :destroyOnClose="true" @ok="handleConfirm"
      dialogClass="new-modal">
      <a-input v-model="newName" :addonBefore="$t('edit.name')" :placeholder="newName"></a-input>
    </a-modal>
    <!--add group modal-->
    <a-modal v-model="groupMVisible" :title="isExistingGroup
      ? $t('actionTitles.sceneClassification')
      : $t('actionTitles.addGroups')
      " :width="600" :footer="null" :destroyOnClose="true" :afterClose="() => (isExistingGroup = false)">
      <AddGroup v-show="!isExistingGroup" @closeModal="groupMVisible = false"></AddGroup>
      <AddGroup v-show="isExistingGroup" @closeModal="groupMVisible = false" :currentNum="1"
        :existingGroup="existingGroup"></AddGroup>
    </a-modal>
    <!--add scenes modal-->
    <HMaterialModal :visible="addScenesVisible" :isFilterScence="true" @close="addScenesVisible = false"
      @handleConfirm="addScenesConfirm" :type="2"></HMaterialModal>
    <!-- 添加影片 -->
    <HMaterialModal :visible="panoramicVisible" :isFilterScence="true" @close="panoramicVisible = false"
      @handleConfirm="addScenesConfirm" :type="1"></HMaterialModal>
    <!--移動場景-->
    <a-modal v-model="moveSceneVisible" :title="'移動分組'" :width="500" :destroyOnClose="true" centered
      dialogClass="new-modal" @ok="moveScene">
      <MoveScene @move="getMoveToId" :group-list="sceneGroups" :curr-id="currMoveSceneId"></MoveScene>
    </a-modal>
    <a-modal v-model="tongPingModal" :title="'對比圖'" :width="375" :destroyOnClose="true" centered dialogClass="new-modal"
      @ok="okTongPing" @cancel="cancelTongPing">
      <div class="tong-ping-box">
        <div class="icon-box" @click="addTongPing(currentScenesId)">
          <img v-if="tongPingObj && tongPingObj.thumb_path" :src="tongPingObj.thumb_path" alt="" class="img-box">
          <a-icon type="plus" class="jiahaoicon" v-else />
        </div>
      </div>
      <div style="margin-top: 20px;display: flex;justify-content: center;width: 100%">
        <a-button type="primary" style="width: 40%;" @click="delTongPing"
          :disabled="!tongPingObj || !tongPingObj.thumb_path">清空</a-button>
      </div>

      <HMaterialModal :visible="tongPingVisible" :isFilterScence="true" @close="tongPingVisible = false"
        @handleConfirmTongPing="tongPingScene" :type="3"></HMaterialModal>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AddGroup from "../../component/AddGroup";
import HMaterialModal from "@/components/HMaterialModal";
import { v4 as uuidv4 } from "uuid";
import EditOptions from "../EditOptions";
import SceneList from "./SceneList";
import GroupList from "./GroupList";
import MoveScene from "./MoveScene";
import BottomTip from "../BottomTip";
export default {
  components: { HMaterialModal, AddGroup, EditOptions, SceneList, GroupList, MoveScene, BottomTip },
  computed: { ...mapGetters(["vrbase", "currentScenesId"]) },
  data() {
    return {
      sceneGroups: [],
      currentGroupIdx: 0,
      selectedGroup: {},
      selectScene: [],
      renameVisible: false,
      addScenesVisible: false,
      panoramicVisible: false,
      groupMVisible: false,
      renameObj: {},
      newName: "",

      editSceneCurId: '',
      editGroupVisible: false,
      groupOptions: [
        { title: this.$t("actionTitles.add"), type: 'add' },
        { title: this.$t("actionTitles.rename"), type: 'rename' },
        { title: this.$t("actionTitles.sceneClassification"), type: 'sceneClassification' },
        { title: this.$t("actionTitles.delete"), type: 'delete' },
      ],
      addScenesGroupVisible: false,
      addSceneOptions: [
        { title: '增加圖片', type: 'addImg' },
        { title: '增加影片', type: 'addVideo' }
      ],
      sceneOptions: [
        { title: "對比圖", src: require('../../assets/img/mob_addTP.png'), type: 'tongping' },
        { title: this.$t('actionTitles.moveTo'), src: require('../../assets/img/mob_moveTo.png'), type: 'moveTo' },
        { title: this.$t('actionTitles.rename'), src: require('../../assets/img/mob_rename.png'), type: 'rename' },
        { title: this.$t('actionTitles.delete'), src: require('../../assets/img/mob_delete.png'), type: 'delete' },
      ],
      moveSceneVisible: false,
      currMoveSceneId: '',
      moveToGroupId: 0,

      isExistingGroup: false,
      existingGroup: {},
      tongPingVisible: false,
      selectTongPingId: "",
      tongPingModal: false,
      tongPingObj: "",
    };
  },
  watch: {
    currentScenesId: {
      handler(newVal) {
        this.$set(this.selectScene, 0, newVal);
        if (this.vrbase.scenes[this.currentScenesId].tongping) {
          this.tongPingObj = this.vrbase.scenes[this.currentScenesId].tongping;
        } else {
          this.tongPingObj = {};
        }
      }
    }
  },
  created() {
    this.sceneGroups = this.vrbase.scene_group.groups;
    this.selectedGroup = this.sceneGroups[0];
    this.selectScene[0] = this.currentScenesId
    this.editSceneCurId = this.currentScenesId;
    if (this.vrbase.scenes[this.currentScenesId].tongping) {
      this.tongPingObj = this.vrbase.scenes[this.currentScenesId].tongping;
    }

  },
  mounted() {
    // let self = this
    // self.$nextTick(()=>{
    //   document.addEventListener('click',(e) => {
    //     if(e.target.className!='group-edit-btns'){
    //       self.editGroupVisible = false
    //     }
    //   })
    // })
    // if (this.vrbase.scenes[this.currentScenesId].tongping && this.vrbase.scenes[this.currentScenesId].tongping.thumb_path){
    //   this.sceneOptions[0].src = this.vrbase.scenes[this.currentScenesId].tongping.thumb_path;
    // }
  },
  methods: {
    delTongPing() {
      this.tongPingObj = {};
      // if (this.vrbase.scenes[this.currentScenesId].tongping){
      //   this.vrbase.scenes[this.currentScenesId].tongping = {};
      // }
    },
    cancelTongPing() {
      if (this.vrbase.scenes[this.currentScenesId].tongping) {
        this.tongPingObj = this.vrbase.scenes[this.currentScenesId].tongping;
      } else {
        this.tongPingObj = {};
      }
    },
    okTongPing() {
      this.vrbase.scenes[this.selectTongPingId].tongping = this.tongPingObj;
      this.tongPingModal = false;
    },
    addTongPing(sceneIdx) {
      this.tongPingVisible = true;
      this.selectTongPingId = sceneIdx;
      // console.log("groupIndex==>",groupIndex,"sceneIdx=======>",sceneIdx)
    },
    tongPingScene(scene) {
      this.tongPingObj = { scene_id: scene.id, thumb_path: scene.thumb_path, angle: scene.angle }
      // console.log("tongPingScene=====>",scene)
      // this.vrbase.scenes[this.selectTongPingId].tongping = {scene_id:scene.id,thumb_path:scene.thumb_path,angle:scene.angle}
      const vrbase = this.vrbase;
      // this.$store.dispatch("saveVRBase", {vrbase, showLoading: true});
      this.tongPingVisible = false;
    },
    //切換組
    titleClick(index, group) {
      this.currentGroupIdx = index;
      this.selectedGroup = group;
    },
    //編輯組彈出編輯option
    editGroup() {
      this.editGroupVisible = true
    },
    //編輯組
    groupOption(type) {
      if ("rename" === type) {
        this.renameVisible = true;
        this.renameObj = this.selectedGroup;
        this.newName = this.selectedGroup.name;
      }
      if ("delete" === type) {
        const _this = this;
        this.$confirm({
          title: _this.$t('edit.editMessage.title'),
          content: _this.$t('edit.editMessage.content'),
          okText: _this.$t('edit.editMessage.okText'),
          okType: "danger",
          cancelText: _this.$t('edit.editMessage.cancelText'),
          onOk() {
            const group = _this.sceneGroups[_this.currentGroupIdx];
            _this.handleDeleteGroup(group);
          },
          onCancel() {
            console.log("取消");
          },
        });
      }
      if ("add" === type) {
        this.groupMVisible = true;
      }
      if ("sceneClassification" === type) {
        this.existingGroup = this.selectedGroup;
        this.isExistingGroup = true;
        this.groupMVisible = true;
      }
      this.editGroupVisible = false
    },
    //刪除組
    handleDeleteGroup(group) {
      if (this.sceneGroups.length == 1) {
        this.$message.error(this.$t('edit.editMessage.deleteGroup'));
        return;
      }
      //過濾刪除的組並重置選中組
      // let newList = [];
      // this.sceneGroups.forEach((item) => {
      //   if (item.name !== group.name) newList.push(item);
      // });
      // if (this.currentGroupIdx === groupIndex) {
      //   this.currentGroupIdx = newList.length - 1;
      // }
      this.$delete(this.sceneGroups, this.currentGroupIdx); // 手機端只能刪除當前選中的組，所以直接用currentGroupIdx
      this.currentGroupIdx = 0;
      // this.sceneGroups = newList;
      this.vrbase.scene_group.groups = this.sceneGroups;
      //被刪除組裡面的場景也要刪除
      console.log("group=", group);
      const sencesList = group.scenes;
      console.log("sencesList=", sencesList);
      for (var i = 0; i < sencesList.length; i++) {
        this.$delete(this.vrbase.scenes, sencesList[i]);
      }
      this.$store.dispatch("setVRBase", this.vrbase);
      this.setCurrentSenceToNew(sencesList);
    },
    handleConfirm() {
      if (this.newName === "") {
        this.$message.error('名稱不能為空')
        return
      }
      if (this.renameObj.name) {
        // group更名
        // 循環數組，找到對應的更名對像
        this.sceneGroups.forEach((item) => {
          if (item.name === this.renameObj.name) item.name = this.newName;
        });
        this.vrbase.scene_group.groups = this.sceneGroups;
      }
      if (this.renameObj.scene_title) {
        //sence更名
        this.vrbase.scenes[this.renameObj.scene_id].scene_title = this.newName;
      }
      this.$store.dispatch("setVRBase", this.vrbase);
      this.renameVisible = false;
      // reset data
      this.newName = "";
    },
    addScenesConfirm(list) {
      if (!list || list.length === 0) {
        this.$message.error(this.$t("edit.editMessage.sceneConfirm"));
        return;
      }
      let type = this.addScenesVisible ? 0 : 1;
      this.addScenesVisible
        ? (this.addScenesVisible = false)
        : (this.panoramicVisible = false);
      let newAddScenes = {};
      let newAddScenesArr = [];
      //獲取選擇的場景id並加入對應分組的scene
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        // 新增場景到model的scenes下
        let sceneStr = uuidv4().replace(/-/g, "");
        let newScene = {
          scene_id: "scene_" + sceneStr.substr(sceneStr.length - 16),
          type: type,
          pid: item.id,
          gid: this.sceneGroups[this.currentGroupIdx].id,
          sort_order: this.getLastSceneSortOrder() + 1,
          scene_title: item.type == 4 ? item.name : item.filename,
          thumb_path: item.type == 4 ? item.cover : item.thumb_path,
          prefix: item.type == 4 ? "" : item.prefix,
          multires: item.type == 4 ? "" : item.multires,
          location: item.url,
          paster: {},
          hotspot: {},
          angle: {
            initview: {
              hlookat: 0,
              vlookat: 0,
            },
            fovrange: { min: 5, max: 120, default: 90 },
            viewrange: {
              hview: { min: -180, max: 180 },
              vview: { min: -90, max: 90 },
            },
          },
        };
        newAddScenes[newScene.scene_id] = newScene; //提供給沙盤使用
        newAddScenesArr.push(newScene);
        this.$set(this.vrbase.scenes, newScene.scene_id, newScene);
        this.sceneGroups[this.currentGroupIdx].scenes.push(newScene.scene_id);
      }
      addScenes(newAddScenesArr);
      this.loadScene(this.currentScenesId);
      this.updateStore(this.vrbase);
      //更新服務器
      this.$emit("updateServer");
    },
    //移動分組後的處理
    groupDragEnd(groupList) {
      this.sceneGroups = groupList
      this.selectedGroup = this.sceneGroups[this.currentGroupIdx]
      this.sceneGroups.forEach((obj, index) => {
        obj.sort_order = index;
      })
      this.vrbase.scene_group.groups = this.sceneGroups
      this.updateStore(this.vrbase);
    },
    //移動場景後處理順序
    sceneDragEnd(sceneList) {
      this.sceneGroups[this.currentGroupIdx].scenes = sceneList
      sceneList.forEach((obj, index) => {
        this.vrbase.scenes[obj].sort_order = index;
      })
      this.updateStore(this.vrbase)
    },
    // 更新store數據
    updateStore(vrbase) {
      this.$store.dispatch("setVRBase", vrbase);
    },
    //切換分組
    loadScene(sceneId) {
      // this.editSceneVisible = true
      this.editSceneCurId = sceneId
      this.$store.dispatch("loadScene", sceneId);
    },
    //添加場景
    onClickAddScene() {
      this.addScenesGroupVisible = true
    },
    //添加場景類型選擇
    addSceneOption(type) {
      if (type == 'addImg') {
        this.addScenesVisible = true
      }
      if (type == 'addVideo') {
        this.panoramicVisible = true
      }
      this.addScenesGroupVisible = false
    },
    getLastSceneSortOrder() {
      //取當前分組中最後一個場景的sort_order
      const currGroupCenceList = this.sceneGroups[this.currentGroupIdx].scenes;
      let lastSortNum = 0
      if (currGroupCenceList && currGroupCenceList.length > 0) {
        const lastSceneId = currGroupCenceList.slice(-1)[0];
        lastSortNum = this.vrbase.scenes[lastSceneId].sort_order;
      }
      return lastSortNum;
    },
    sceneOption(type) {
      let sceneIdx = this.editSceneCurId
      if ('tongping' === type) {
        // console.log("moveTo", sceneIdx);
        // this.currMoveSceneId = sceneIdx
        this.selectTongPingId = sceneIdx;
        this.tongPingModal = true;
      }
      if ("rename" === type) {
        console.log("rename", sceneIdx);
        this.renameObj = this.vrbase.scenes[sceneIdx];
        this.newName = this.vrbase.scenes[sceneIdx].scene_title;
        this.renameVisible = true;
      }
      if ('moveTo' === type) {
        console.log("moveTo", sceneIdx);
        this.currMoveSceneId = sceneIdx
        this.moveSceneVisible = true;
      }
      if ("delete" === type) {
        console.log("delete", sceneIdx);
        const _this = this;
        this.$confirm({
          title: _this.$t('edit.editMessage.title'),
          content: _this.$t('edit.editMessage.content'),
          okText: _this.$t('edit.editMessage.okText'),
          okType: "danger",
          cancelText: _this.$t('edit.editMessage.cancelText'),
          onOk() {
            _this.handleDeleteScene(sceneIdx);
          },
          onCancel() {
            console.log("取消");
          },
        });
      }
    },
    //移動場景分組
    moveScene() {
      if (this.moveToGroupId == 0) {
        this.$message.error('沒有選擇其他分組')
        return
      } else {
        this.vrbase.scene_group.groups.some((group, index) => {
          group.scenes.forEach((obj, i) => {
            if (obj == this.currMoveSceneId) {
              this.vrbase.scene_group.groups[index].scenes.splice(i, 1)
              return
            }
          })
        })
        this.vrbase.scene_group.groups.some((group, index) => {
          if (group.id == this.moveToGroupId) {
            this.vrbase.scene_group.groups[index].scenes.push(this.currMoveSceneId)
          }
        })

        this.moveSceneVisible = false
        this.moveToGroupId = 0
        this.$store
          .dispatch("saveVRBase", { vrbase: this.vrbase, showLoading: true });
      }
    },
    getMoveToId(item) {
      this.moveToGroupId = item.id
    },
    handleDeleteScene(sceneIdx) {
      // 至少要保留一個場景
      if (Object.keys(this.vrbase.scenes).length === 1) {
        this.$message.error(this.$t('edit.editMessage.deleteScene'));
        return;
      }
      // 場景對像刪除
      this.$delete(this.vrbase.scenes, sceneIdx);
      // this.sceneGroups = this.vrbase.scenes[sceneIdx];
      // 分組內部的場景刪除，需要遍歷全部分組的全部場景刪除對應id
      for (var i = 0; i < this.sceneGroups.length; i++) {
        let sceneIdList = this.sceneGroups[i].scenes;
        const filArr = sceneIdList.filter((item) => item !== sceneIdx);
        this.sceneGroups[i].scenes = filArr;
        this.$set(this.sceneGroups, i, this.sceneGroups[i]);
      }
      this.vrbase.scene_group.groups = this.sceneGroups;
      this.$store.dispatch("setVRBase", this.vrbase);
      this.setCurrentSenceToNew([sceneIdx]);
    },
    // 當前場景被刪除後需要重新制定場景, 當前分組沒有就到全部場景中去取第一個，否則取分組第一個
    setCurrentSenceToNew(deletedSenceIdList) {
      if (!deletedSenceIdList.includes(this.currentScenesId)) return;
      const currentGroupSences = this.sceneGroups[this.currentGroupIdx].scenes;
      if (currentGroupSences && currentGroupSences.length > 0) {
        this.$store.dispatch("setCurrentScnId", currentGroupSences[0]);
      } else {
        this.getFirstSenceFromAll();
      }
      this.loadScene(this.currentScenesId);
    },

    // 獲取全部場景的第一個場景、
    getFirstSenceFromAll() {
      const scenesArr = Object.keys(this.vrbase.scenes);
      const currId =
        scenesArr.length > 0
          ? this.vrbase.scenes[scenesArr[0]]["scene_id"]
          : "";
      this.$store.dispatch("setCurrentScnId", currId);
    },
  },
};
</script>

<style lang="less" scoped>
.scenes-bg {
  width: 100%;
  color: white;
  /*background-color: #141414;*/
}

.tong-ping-box {
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-box {
  border: 1px solid #cccccc;
  border-radius: 5px;
  overflow: hidden;
  width: 40%;
  padding-bottom: 40%;
  height: 0;
  position: relative;
}

.jiahaoicon {
  font-size: 20px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.img-box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>
